var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            "label-position": "right",
            inline: "",
            "label-width": "110px",
            rules: _vm.rules
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { id: "chargeTypeName", span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "活动类型名称", prop: "activityTypeName" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        staticStyle: { width: "320px" },
                        attrs: {
                          maxlength: "20",
                          clearable: "",
                          type: "text",
                          placeholder: "请输入活动类型名称"
                        },
                        model: {
                          value: _vm.childData.activityTypeName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "activityTypeName", $$v)
                          },
                          expression: "childData.activityTypeName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: {
                          clearable: "",
                          maxlength: "200",
                          type: "textarea",
                          placeholder: "请输入备注",
                          autosize: { minRows: 3, maxRows: 3 }
                        },
                        on: { input: _vm.handleRemarkInput },
                        model: {
                          value: _vm.childData.activityRemark,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "activityRemark", $$v)
                          },
                          expression: "childData.activityRemark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.isBtnDisabled },
              on: { click: _vm.handCreate }
            },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }